import {combineReducers} from 'redux';
import Auth from './Auth';
import Theme from './Theme';
import Setup from './Setup';
import Ui from './Ui';
import Notifications from './Notifications';
import StreamEvents from "./StreamEvents";

const reducers = combineReducers({
    theme: Theme,
    auth: Auth,
    setup: Setup,
    ui: Ui,
    notifications: Notifications,
    streamEvents: StreamEvents
});

export default reducers;